<div class="table-wrapper" [style.height.px]="maxHeight">
  <table #table mat-table [dataSource]="dataSource">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="common/name"></span>
      </th>
      <td mat-cell *matCellDef="let element; index as index">
        <span [attr.data-testid]="'name-' + index">{{ element.name }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="creator_admin_user_id">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="users_roles/team_creator"></span>
      </th>
      <td mat-cell *matCellDef="let element; index as index">
        <span [attr.data-testid]="'user-' + index">{{ element.email }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="creation_time">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="users_roles/date_of_creation"></span>
      </th>
      <td mat-cell *matCellDef="let element">
        <span>{{ element.creation_time | dateTimezone: 'shortDate' }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="optins/type"></span>
      </th>
      <td mat-cell *matCellDef="let element; index as index">
        <span [attr.data-testid]="'type-' + index">{{ element.typeLabel }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="optins/recurring-notification-title"></span>
      </th>
      <td mat-cell *matCellDef="let element; index as index">
        <span [attr.data-testid]="'title-' + index">{{ element.title }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="scenarios">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="optins/scenario_names"></span>
      </th>
      <td mat-cell *matCellDef="let element; index as optinIndex">
        <div *ngFor="let scenario of element.scenariosPreview; trackBy: trackByFn; index as scenarioId">
          <app-site-icon-and-name [item]="scenario?.site"> {{ scenario?.site?.name }} </app-site-icon-and-name>&nbsp;
          <span
            [attr.data-testid]="'scenario-' + optinIndex + '-' + scenarioId"
            class="optins-table-link"
            (click)="redirectToScenario(scenario)">
            {{ scenario.name }}
          </span>
        </div>
        <div
          class="optins-table-link"
          *ngIf="element.scenariosList.length > 2"
          (click)="showMoreScenarios(element.scenariosList)">
          {{ element.listMoreLabel }}
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="opted_in_nusers">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="users_roles/number_of_users"></span>
      </th>
      <td mat-cell *matCellDef="let element; index as index">
        <span [attr.data-testid]="'nusers-' + index">{{ element.opted_in_nusers }}</span>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>
        <span translate="actions"></span>
      </th>
      <td mat-cell *matCellDef="let element; index as index">
        <div class="actions">
          <button
            [attr.data-testid]="'edit-' + index"
            mat-icon-button
            color="primary"
            type="button"
            (click)="askForEdit(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button
            [attr.data-testid]="'delete-' + index"
            mat-icon-button
            color="warn"
            type="button"
            [matTooltipDisabled]="!element.usedInSegment"
            [matTooltip]="'optins/used-in-segment' | translate"
            [disabled]="element.usedInSegment"
            (click)="askForDelete(element)">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr [class.hidden]="row.hide" mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>

<ng-template #formTemplateRef>
  <form [formGroup]="form">
    <p>
      <mat-form-field class="w-100">
        <mat-label translate="common/name"></mat-label>
        <input matInput formControlName="name" type="text" data-testid="name" />
        <mat-error
          data-testid="error-required"
          *ngIf="form.get('name').hasError('required')"
          translate="common/form_errors/required"></mat-error>
        <mat-error
          data-testid="error-unique-name"
          *ngIf="form.get('name').hasError('unique-name')"
          translate="optins/form/errors/unique-name"></mat-error>
      </mat-form-field>
    </p>
    <p>
      <app-select data-testid="type" [control]="form.get('type')" [items]="optinTypeChoicesList" labelKey="optins/type">
      </app-select>
    </p>
    <ng-container *ngIf="form.getRawValue().type as optinTypeForm">
      <p
        *ngIf="
          optinTypeForm === OptinTypeEnum.OPTIN_TYPE_RECURRING_NOTIF_INSTAGRAM ||
          optinTypeForm === OptinTypeEnum.OPTIN_TYPE_RECURRING_NOTIF_MESSENGER
        ">
        <mat-form-field class="w-100">
          <mat-label translate="optins/recurring-notification-title"></mat-label>
          <input matInput formControlName="title" type="text" data-testid="title" [maxlength]="titleMaxLength" />
          <mat-error
            data-testid="error-required"
            *ngIf="form.get('title').hasError('required')"
            translate="common/form_errors/required"></mat-error>
          <mat-error
            data-testid="error-max-length"
            *ngIf="form.get('title').hasError('maxLength')"
            translate="common/form_errors/maxlength"></mat-error>
          <mat-error
            data-testid="unique-title"
            *ngIf="form.get('title').hasError('unique-title')"
            translate="optins/form/errors/unique-title"></mat-error>
          <mat-error
            data-testid="error-unique-name-title-type"
            *ngIf="form.get('title').hasError('unique-name-title-type')"
            translate="optins/form/errors/unique-name-title-type"></mat-error>
        </mat-form-field>
      </p>
    </ng-container>
  </form>
</ng-template>

<ng-template #scenariosListTemplateRef>
  <div *ngFor="let scenario of optinScenarios; trackBy: trackByFn; index as scenarioId">
    <p>
      <app-site-icon-and-name [item]="scenario.site"> {{ scenario?.site?.name }} </app-site-icon-and-name>&nbsp;
      <span class="optins-table-link" (click)="redirectToScenario(scenario)">
        {{ scenario.name }}
      </span>
    </p>
  </div>
</ng-template>
